import React from 'react';
import { connect } from 'react-redux';
import success from '../../assets/images/success.svg';

class OrderComplete extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            newOrderId: ''
        };
    }

    render() {
        return (
            <div className="checkout-page-wrapper">
                <div className="success-wrapper">
                    <div className="success-circle" >
                        <img src={success} /> 
                    </div>
                    <div className="success-message-window">
                        <div className="text-window">
                            <p>Order Complete!</p>
                            <p>Order ID: {this.props.cart.completed_order_id}</p>
                            <p className="subcheckout-label">Thanks so much for your order!  A receipt will be sent to your e-mail address which will include the estimated pickup/delivery time.</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        cartItem: state.cartItem,
        cart: state.cart
    };
};

export default connect(mapStateToProps)(OrderComplete);
